import { storeToRefs } from 'pinia'

import { useStoreContacts } from '@/entities/contact'
import { useStoreGroups } from '@/entities/contact-group'

import { useLocalization } from '@/shared/composables/localization'

export function useSearchGroups (number: string): string[] {
  const storeGroups = useStoreGroups()
  const { groups } = storeToRefs(storeGroups)
  const storeContacts = useStoreContacts()
  const { t } = useLocalization()
  const contact = storeContacts.findByInternalNumber(number)
  const result: string[] =
    groups.value
      .filter((item) => {
        if (contact) {
          return contact.groupIds.find((x: string) => x === item.guid)
        }
        return
      })
      .map((item) => item.name)

  if (contact) return result
  return [t('common.external')]
}
